import React, { useState } from 'react';
import { supabase } from '../supabase';
import { useNavigate, Link } from 'react-router-dom';
import LogoImg from '../ChatGPT Image Jun 26, 2025, 12_35_25 AM.png';

const Logo = () => (
  <span className="flex items-center justify-center mb-6" style={{ alignItems: 'center' }}>
    <img src={LogoImg} alt="DevelloTech Logo" style={{ width: 96, height: 96, objectFit: 'contain', marginRight: 0, padding: 0, display: 'block' }} />
    <span
      className="text-3xl font-bold tracking-tight"
      style={{
        background: 'linear-gradient(90deg, #1761A0 0%, #2ED8C3 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        color: 'transparent',
        marginLeft: -12,
        paddingLeft: 0,
      }}
    >
      DevelloTech
    </span>
  </span>
);

function getFriendlyError(error) {
  if (!error) return 'An unexpected error occurred.';
  const msg = error.message || error.error_description || '';
  if (msg.includes('Invalid login')) return 'Invalid email or password.';
  if (msg.includes('Email not confirmed')) return 'Please verify your email before signing in.';
  if (msg.includes('rate limit') || msg.includes('too many')) return 'Too many attempts. Please try again later.';
  return msg || 'An unexpected error occurred.';
}

const ClientLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const { data, error: signInError } = await supabase.auth.signInWithPassword({
        email: formData.email,
        password: formData.password,
      });
      if (signInError) throw signInError;
      const loggedInUser = data.user;

      const { data: clientDoc } = await supabase
        .from('clients').select('*').eq('id', loggedInUser.id).single();

      if (clientDoc && clientDoc.user_type === 'client') {
        setSuccess('Signed in successfully! Redirecting to your dashboard...');
        setTimeout(() => {
          navigate('/client-dashboard');
        }, 2000);
      } else if (clientDoc) {
        await supabase.auth.signOut();
        setError('This account is not a client account. Please use the contractor login.');
      } else {
        await supabase.auth.signOut();
        setError('Client account not found. Please register as a client first.');
      }

    } catch (err) {
      setError(getFriendlyError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl p-8 shadow-strong">
          <div className="text-center mb-8">
            <Logo />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Client Sign In</h2>
            <p className="text-gray-600">Welcome back! Sign in to access your quotes</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => handleInputChange('email', e.target.value)}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                placeholder="Enter your email"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <input
                type="password"
                value={formData.password}
                onChange={(e) => handleInputChange('password', e.target.value)}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                placeholder="Enter your password"
              />
            </div>

            {error && <div className="text-red-600 text-sm text-center">{error}</div>}
            {success && <div className="text-green-600 text-sm text-center">{success}</div>}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-white py-3 px-4 rounded-lg font-medium hover:bg-primary-dark transition-colors disabled:opacity-50"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className="text-center mt-6">
            <p className="text-sm text-gray-600">
              Don't have a client account?{' '}
              <Link to="/client-register" className="text-primary hover:text-primary-dark font-medium">
                Create account
              </Link>
            </p>
          </div>

          <div className="text-center mt-4">
            <p className="text-sm text-gray-500">
              Are you a contractor?{' '}
              <Link to="/account" className="text-primary hover:text-primary-dark font-medium">
                Sign in here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientLogin; 